import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { BulkStatusMaxSizeErrorMessage } from '../../../sharedComponents/bulkStatusUpdate/BulkStatusMaxSizeErrorMessage';

type BulkStatusVehicleMaxSizeErrorMessageProps = {
    readonly totalCount?: number;
    readonly maxBulkSize: number;
};

export const BulkStatusVehicleMaxSizeErrorMessage: FunctionComponent<BulkStatusVehicleMaxSizeErrorMessageProps> = ({
    totalCount,
    maxBulkSize,
}) => {
    const { formatMessage } = useIntl();

    return (
        <BulkStatusMaxSizeErrorMessage
            maxBulkSizeExceededText={formatMessage(
                { id: 'outboundOrderBook.compoundManagement.bulkStatusUpdate.error.maxBulkSizeExceeded' },
                { count: maxBulkSize },
            )}
            maxSelectionSizeText={formatMessage(
                { id: 'outboundOrderBook.compoundManagement.bulkStatusUpdate.error.maxSelectionSize' },
                { count: maxBulkSize },
            )}
            selectionSizeText={formatMessage({
                id: 'outboundOrderBook.compoundManagement.bulkStatusUpdate.error.selectionSize',
            })}
            totalCount={totalCount}
        />
    );
};
